import React, { useState, useEffect } from "react";
import { Table, Spin } from "antd";
import api from "../../../api/index";
import moment from "moment";

export default function Tab3() {
	const [capitalData, setCapitalData] = useState([]);
	const [loading, setLoading] = useState(false);
	const [loadingCapital, setLoadingCapital] = useState(false);
	const [suppliers, setSuppliers] = useState([]);

	useEffect(() => {
		getSuppliers();
		getCapital();
	}, []);

	const getCapital = async () => {
		setLoadingCapital(true);
		try {
			await api.get(`api/marioliva/reports/kapital`).then((res) => {
				setCapitalData(JSON.parse(res.data));
			});
		} catch (error) {
			console.error(error.message);
		} finally {
			setLoadingCapital(false);
		}
	};

	const getSuppliers = async () => {
		setLoading(true);
		try {
			await api.get(`api/marioliva/suppliers`).then((res) => {
				setSuppliers(JSON.parse(res.data));
			});
		} catch (error) {
			console.error(error.message);
		}
		setLoading(false);
	};

	const suppliersColumns = [
		{
			title: "Ta'minotchi",
			dataIndex: "supplierName",
			key: "supplierName",
		},

		{
			title: "Xarid Sanasi",
			dataIndex: "firstPurchaseDate",
			key: "firstPurchaseDate",
			render: (text, record) => {
				const formattedText = text ? moment(text).format("DD.MM.YYYY") : "";
				return `${formattedText}`;
			},
		},
		{
			title: "Xarid vaqtidan otgan kun",
			dataIndex: "daysSinceFirstPurchase",
			key: "daysSinceFirstPurchase",
			sorter: (a, b) => a.daysSinceFirstPurchase - b.daysSinceFirstPurchase,
		},
		{
			title: "So'mda olingan tovardan qarzimiz",
			dataIndex: "debtUZS",
			key: "debtUZS",
			sorter: (a, b) => a.debtUZS - b.debtUZS,
			render: (text, record) => {
				const formattedText = new Intl.NumberFormat("fr-FR").format(text).replace(/\s/g, "   ");
				return `${formattedText}`;
			},
		},
		{
			title: "Dollarda olingan tovardan qarzimiz",
			dataIndex: "debtUSD",
			key: "debtUSD",
			sorter: (a, b) => a.debtUSD - b.debtUSD,
			render: (text, record) => {
				const formattedText = new Intl.NumberFormat("fr-FR").format(text).replace(/\s/g, "   ");
				return `${formattedText}`;
			},
		},
		{
			title: "Qoldiq maxsulot summasi(USD)",
			dataIndex: "remainingStock",
			key: "remainingStock",
			sorter: (a, b) => a.remainingStock - b.remainingStock,
			render: (text, record) => {
				const formattedText = new Intl.NumberFormat("fr-FR").format(text).replace(/\s/g, "   ");
				return `${formattedText}`;
			},
		},
		{
			title: "Qoldiq maxsulot summasi(UZS)",
			dataIndex: "remainingStock",
			key: "remainingStock",
			sorter: (a, b) => a.remainingStock - b.remainingStock,
			render: (text, record) => {
				const formattedText = new Intl.NumberFormat("fr-FR").format(text).replace(/\s/g, "   ");
				return `${formattedText}`;
			},
		},

		{
			title: "Sotilgan mahsulot summasi",
			dataIndex: "soldQuantity",
			key: "soldQuantity",
			sorter: (a, b) => a.soldQuantity - b.soldQuantity,
			render: (text, record) => {
				const formattedText = new Intl.NumberFormat("fr-FR").format(text).replace(/\s/g, "   ");
				return `${formattedText}`;
			},
		},
	];

	return (
		<>
			<h1 className="text-lg mt-10 font-semibold ml-2">Kapital</h1>

			{loadingCapital ? (
				<div className="flex items-center justify-center mt-5">
					<Spin />
				</div>
			) : (
				<>
					<div className="grid grid-cols-2  lg:grid-cols-3 xl:grid-cols-4 gap-5 mt-10">
						{capitalData.map((cash, idx) => {
							return (
								<div className="flex h-[120px]  w-[250px] flex-col gap-4 items-center rounded-3xl bg-white drop-shadow-xl">
									<h1 className="font-poppins  mt-5 text-xl font-bold text-[#425166]">
										{cash.name}
									</h1>

									<h1 className="font-poppins  text-xl font-bold text-[#151D48]">
										{" "}
										{new Intl.NumberFormat("fr-FR").format(cash.summa).replace(/\s/g, "  ")}{" "}
									</h1>
								</div>
							);
						})}
					</div>
				</>
			)}

			<h1 className="text-lg mt-10 font-semibold">Ta’minotchilar</h1>
			<div>
				<Table
					columns={suppliersColumns}
					dataSource={suppliers}
					pagination={false}
					className="mt-6 w-full"
					bordered
					sticky={true}
					loading={loading}
				/>
			</div>
		</>
	);
}
